const LOYALTYCRM_SIGNUP_CONSTANT = {
  DESKTOP_MAX_WIDTH: '(max-width: 1023px)',
};

export const SIGN_UP_EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default LOYALTYCRM_SIGNUP_CONSTANT;
export const SUBSCRIBE_TO_LOYALTY = 'subscribeToLoyalty';
export const SUCCESSFUL = 'Successful';
export const UNSUCCESSFUL = 'Unsuccessful';
